import { LogManager } from '../../../../common/port/log/log.manager.port';
import { AccountAverageWorkingHoursTimeSeriesAggregateRootMapper } from '../../../../infrastructure/mappers/org-metrics/working-hours/account-average-working-hours-time-series.aggregate-root.mapper';
import { GetAccountAverageWorkingHoursTimeSeriesRequestDto } from '../../../dtos/org-metrics/working-hours/get-account-average-working-hours-time-series.request.dto';
import { GetAccountAverageWorkingHoursTimeSeriesResponseDto } from '../../../dtos/org-metrics/working-hours/get-account-average-working-hours-time-series.response.dto';
import { GetAccountAverageWorkingHoursTimeSeriesQuery } from '../../../queries/org-metrics/working-hours/get-account-average-working-hours-time-series.query';

export class GetAccountAverageWorkingHoursTimeSeriesController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountAverageWorkingHoursTimeSeriesQuery,
    protected readonly mapper: AccountAverageWorkingHoursTimeSeriesAggregateRootMapper
  ) {}

  async get(
    props: GetAccountAverageWorkingHoursTimeSeriesRequestDto
  ): Promise<GetAccountAverageWorkingHoursTimeSeriesResponseDto> {
    try {
      const result = await this.query.execute(props);
      return result.map((res) => this.mapper.toResponse(res));
    } catch (error) {
      throw new Error(
        `GetAccountAverageWorkingHoursTimeSeriesController.get encountered an error ${error}`
      );
    }
  }
}
